import type { HTMLAttributes } from 'react';

interface DividerProps extends HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical';
  text?: string;
  className?: string;
}

export default function Divider({
  orientation = 'horizontal',
  text,
  className = '',
  ...props
}: Readonly<DividerProps>) {
  const isHorizontal = orientation === 'horizontal';

  if (isHorizontal) {
    if (text) {
      // Horizontal with centered text
      return (
        <div
          className={`flex items-center gap-4 my-4 ${className}`}
          {...props}
        >
          <div className="h-px flex-1 bg-gray-300" />
          <span className="text-sm font-medium text-gray-500 whitespace-nowrap">
            {text}
          </span>
          <div className="h-px flex-1 bg-gray-300" />
        </div>
      )
    }

    // simple horizontal line
    return (
      <div
        className={`h-px bg-gray-300 my-4 ${className}`}
        {...props}
      />
    );
  }

  // Vertical divider
  return (
    <div
      className={`w-px bg-gray-300 mx-6 ${className}`}
      {...props}
    />
  );
}